import { Link } from "react-router-dom";

const categories = [
  {
    label: "仙剑正传系列",
    tag: "正传",
    desc: "从余杭镇少年到女娲后人，正传系列经典不容错过",
    icon: "ri-sword-line",
    image:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20scene%2C%20ancient%20jade-green%20mountain%20peak%20with%20a%20glowing%20sword%20planted%20in%20stone%2C%20mist%20and%20pale%20gold%20light%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20serene%20mystical%20atmosphere&width=800&height=600&seq=cat-1&orientation=landscape",
  },
  {
    label: "周边作品",
    tag: "衍生",
    desc: "神器现世与宿命轮回，同一世界观下的衍生故事",
    icon: "ri-vip-diamond-line",
    image:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20scene%2C%20ancient%20bronze%20artifact%20glowing%20with%20jade-green%20and%20golden%20runes%20on%20a%20stone%20altar%2C%20misty%20background%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20mystical%20atmosphere&width=800&height=600&seq=cat-2&orientation=landscape",
  },
  {
    label: "相关仙侠剧",
    tag: "相关仙侠",
    desc: "古剑奇谭、花千骨、苍兰诀……扩展你的仙侠片单",
    icon: "ri-planet-line",
    image:
      "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20scene%2C%20vast%20jade-green%20immortal%20realm%20with%20floating%20islands%20and%20golden%20clouds%2C%20cinematic%20painting%20style%2C%20highly%20detailed%2C%20serene%20mystical%20atmosphere&width=800&height=600&seq=cat-3&orientation=landscape",
  },
];

export default function CategoryShortcuts() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        {categories.map((category) => (
          <Link
            key={category.tag}
            to={`/category?cat=${encodeURIComponent(category.tag)}`}
            className="group relative block rounded-lg overflow-hidden border border-background-200 h-48 md:h-56 hover:border-primary-300 transition-colors"
          >
            <img
              src={category.image}
              alt={category.label}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/40 to-transparent"></div>
            <div className="relative h-full flex flex-col justify-end p-5 md:p-6">
              <span className="w-11 h-11 rounded-lg bg-accent-500 text-foreground-950 flex items-center justify-center text-xl mb-4">
                <i className={category.icon}></i>
              </span>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-white">
                {category.label}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-background-200 leading-relaxed">
                {category.desc}
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs text-accent-300 group-hover:gap-2 transition-all">
                进入分类
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}